export const SNAPSHOT_EXPORT_DIAGNOSTIC_PREFIX = '[snapshot-export] ';

export type SnapshotExportFailurePhase = 'archive-export' | 'scope-resolution';

export type SnapshotExportFailureCode =
  | 'database-subdoc-plan-empty'
  | 'database-subdoc-unavailable'
  | 'referenced-blob-unavailable'
  | 'snapshot-transform-failed'
  | 'unexpected';

export type SnapshotExportFailureDiagnostic = {
  code: SnapshotExportFailureCode;
  event: 'snapshot-export-failed';
  errorName: string;
  phase: SnapshotExportFailurePhase;
};

export function createSnapshotExportFailureDiagnostic(
  phase: SnapshotExportFailurePhase,
  error: unknown
): SnapshotExportFailureDiagnostic {
  const message = error instanceof Error ? error.message : '';
  let code: SnapshotExportFailureCode = 'unexpected';

  if (message.includes('No database subdoc candidates to load')) {
    code = 'database-subdoc-plan-empty';
  } else if (message.includes('Cannot export sharded database')) {
    code = 'database-subdoc-unavailable';
  } else if (message.includes('Cannot export referenced blob')) {
    code = 'referenced-blob-unavailable';
  } else if (message.includes('Snapshot export failed for document')) {
    code = 'snapshot-transform-failed';
  }

  return {
    code,
    errorName:
      error instanceof Error
        ? error.name.replace(/[^a-z0-9_.-]/gi, '').slice(0, 64) || 'Error'
        : 'UnknownError',
    event: 'snapshot-export-failed',
    phase,
  };
}

export function reportSnapshotExportFailure(
  phase: SnapshotExportFailurePhase,
  error: unknown
): void {
  console.error(
    `${SNAPSHOT_EXPORT_DIAGNOSTIC_PREFIX}${JSON.stringify(
      createSnapshotExportFailureDiagnostic(phase, error)
    )}`
  );
}
